import React from "react";
import tiger0 from "../images/tiger0.png";
import "./ai-command-hints.css";

const AI_COMMANDS = [
  {
    id: "user_watch",
    icon: "fa-eye",
    label: "Watch a member",
    desc: "Report when someone says something specific",
    template:
      "Watch [member name] and report back every [interval] if they send any messages about [keyword or topic]",
  },
  {
    id: "monitoring",
    icon: "fa-search",
    label: "Monitor keywords",
    desc: "Scan recent messages for specific terms",
    template:
      "Monitor this chat for any mentions of [keyword] and report back with a summary",
  },
  {
    id: "summary",
    icon: "fa-file-text-o",
    label: "Summarize chat",
    desc: "Get a summary of recent conversation",
    template:
      "Summarize the last [24 hours / 3 days / week] of conversation in this channel",
  },
  {
    id: "task_check",
    icon: "fa-check-square-o",
    label: "Check tasks",
    desc: "Review pending and overdue tasks",
    template:
      "Check and summarize all pending and overdue tasks, and call out anything that needs attention",
  },
];

const TIGER_EXAMPLES = [
  {
    id: "assign",
    icon: "fa-user-plus",
    label: "Assign a task",
    desc: "Assign something to a specific person",
    template: "[Name] pakiasikaso yung [task] today",
    tag: "Assignment",
  },
  {
    id: "followup",
    icon: "fa-refresh",
    label: "Follow up",
    desc: "Remind someone about a pending item",
    template: "[Name] pafollow up yung [topic] tomorrow",
    tag: "Reminder",
  },
  {
    id: "quickcheck",
    icon: "fa-search",
    label: "Quick check",
    desc: "Ask someone to review or check something",
    template: "[Name] pakicheck yung [item]",
    tag: "Review",
  },
  {
    id: "request",
    icon: "fa-commenting-o",
    label: "Simple request",
    desc: "Make a casual request in chat",
    template: "[Name] pasend yung [document or file] later",
    tag: "General",
  },
];

export function TigerZeroHints({ onSelectHint, onDismiss }) {
  return (
    <div className="ai-command-hints ai-command-hints--tiger">
      <div className="ai-command-hints__header">
        <img
          src={tiger0}
          alt="Tiger ZERO AI"
          className="ai-command-hints__header-img"
        />
        <div className="ai-command-hints__header-text">
          <span className="ai-command-hints__header-label">Tiger ZERO AI</span>
          <span className="ai-command-hints__header-sub">
            Task extractor · understands Filipino, Taglish &amp; Bisaya
          </span>
        </div>
        <button
          className="ai-command-hints__dismiss"
          onClick={onDismiss}
          aria-label="Dismiss"
          type="button"
        >
          <i className="fa fa-times" />
        </button>
      </div>

      <div className="ai-command-hints__grid">
        {TIGER_EXAMPLES.map((ex) => (
          <button
            key={ex.id}
            className="ai-command-hint-card ai-command-hint-card--tiger"
            onClick={() => onSelectHint(ex.template)}
            type="button"
          >
            <span className="ai-command-hint-card__icon">
              <i className={`fa ${ex.icon}`} />
            </span>
            <span className="ai-command-hint-card__body">
              <span className="ai-command-hint-card__label">
                {ex.label}
                <span className="ai-command-hint-card__tag">{ex.tag}</span>
              </span>
              <span className="ai-command-hint-card__template">
                {ex.template}
              </span>
              <span className="ai-command-hint-card__desc">{ex.desc}</span>
            </span>
            <i className="fa fa-chevron-right ai-command-hint-card__arrow" />
          </button>
        ))}
      </div>
    </div>
  );
}

function AICommandHints({ onSelectHint, onDismiss }) {
  return (
    <div className="ai-command-hints">
      <div className="ai-command-hints__header">
        <span className="ai-command-hints__header-icon">
          <i className="fa fa-bolt" />
        </span>
        <span className="ai-command-hints__header-label">AI Commands</span>
        <span className="ai-command-hints__header-sub">
          · tap a command to get started
        </span>
        <button
          className="ai-command-hints__dismiss"
          onClick={onDismiss}
          aria-label="Dismiss"
          type="button"
        >
          <i className="fa fa-times" />
        </button>
      </div>

      <div className="ai-command-hints__grid">
        {AI_COMMANDS.map((cmd) => (
          <button
            key={cmd.id}
            className="ai-command-hint-card"
            onClick={() => onSelectHint(cmd.template)}
            type="button"
          >
            <span className="ai-command-hint-card__icon">
              <i className={`fa ${cmd.icon}`} />
            </span>
            <span className="ai-command-hint-card__body">
              <span className="ai-command-hint-card__label">{cmd.label}</span>
              <span className="ai-command-hint-card__desc">{cmd.desc}</span>
            </span>
            <i className="fa fa-chevron-right ai-command-hint-card__arrow" />
          </button>
        ))}
      </div>
    </div>
  );
}

export default AICommandHints;
